// @flow
import store from '@/store/store';

const hasPermission = (permissionName: string): Boolean => {
  const webPermissions = store.getters['auth/webPermission'];
  return webPermissions.some(({ name }) => name === permissionName);
};

export default hasPermission;
